import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import {ValueScoreMessages} from './messages';
import {getValueBucket} from './valueScoreHelper';

/* CSS */
import './index.scss';

/**
 * @param valuePercentage
 * @param intl
 */
const ValueScore = ({valuePercentage, intl}) => {
  const ValueScoreObj = getValueBucket(valuePercentage);
  const {name, value} = ValueScoreObj;

  /**
   * This method return array of highlighted or unhighlighted value bar
   * @param  {Number} value
   * @return {Array}
   */
  const createValueScore = (value) => {
    const ValueScores = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= value) {
        ValueScores.push(<span key={i} className={`ValueScore__dot ValueScore__${i} ValueScore__highlighted`} />);
      } else {
        ValueScores.push(<span key={i} className={`ValueScore__dot ValueScore__${i} ValueScore__unhighlighted`} />);
      }
    }

    return ValueScores;
  };

  return (
    <div className="ValueScore">
      <div className="ValueScore__value">{createValueScore(value)}</div>
      <span className="ValueScore__text">{intl.formatMessage(ValueScoreMessages[`${name}`])}</span>
    </div>
  );
};

ValueScore.propTypes = {
  /* Listing value percentage */
  valuePercentage: PropTypes.number,

  /* Intl for translation */
  intl: PropTypes.object.isRequired,
};

export default injectIntl(ValueScore);
